let hasWarnedAboutInvalidProcessRunDownloadTimeout = false;

export const getConfig = () => {
  const httpTimeoutMs = 300000;
  const configuredProcessRunDownloadTimeout =
    import.meta.env.VITE_PROCESS_RUN_DOWNLOAD_TIMEOUT_MS?.trim();
  let processRunDownloadTimeoutMs = httpTimeoutMs;
  if (configuredProcessRunDownloadTimeout) {
    const configuredTimeoutMs = Number(configuredProcessRunDownloadTimeout);
    if (Number.isFinite(configuredTimeoutMs) && configuredTimeoutMs > 0) {
      processRunDownloadTimeoutMs = configuredTimeoutMs;
    } else if (!hasWarnedAboutInvalidProcessRunDownloadTimeout) {
      console.warn(
        "Invalid VITE_PROCESS_RUN_DOWNLOAD_TIMEOUT_MS; using the default HTTP timeout of 300000 ms.",
      );
      hasWarnedAboutInvalidProcessRunDownloadTimeout = true;
    }
  }
  const name = import.meta.env.VITE_ENVIRONMENT || "dev";
  const authTenantId =
    import.meta.env.VITE_AUTH_TENANT_ID ||
    "c5546184-c827-45e1-bdca-78353c329c48";
  const authClientAppId =
    import.meta.env.VITE_AUTH_CLIENT_APPID ||
    "ba4336af-ab71-43de-8886-fa8da0d01f63";
  const authServerAppId =
    import.meta.env.VITE_AUTH_SERVER_APPID ||
    "1e3ea49f-bce2-43ab-8091-ee3363072ca7";

  let backendUrl = "";
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case "prod":
      backendUrl = "https://prod.mps.mpi.app.medi.de";
      break;
    case "stage":
      backendUrl = "https://stage.mps.mpi.app.medi.de";
      break;
    case "dev":
      backendUrl = "https://dev.mps.mpi.app.medi.de";
      break;
    default:
      backendUrl = "https://localhost:6202";
      break;
  }

  return {
    name: name,
    authTenantId: authTenantId,
    authClientAppId: authClientAppId,
    authServerAppId: authServerAppId,
    httpTimeoutMs,
    processRunDownloadTimeoutMs,
    backendUrl: backendUrl,
    apiUrl: "mceapi",
  };
};

export const getConfigName = (): "local" | "dev" | "stage" | "prod" => {
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case "prod":
      return "prod";
    case "stage":
      return "stage";
    case "dev":
      return "dev";
    default:
      return "local";
  }
};
